export default "<p>supervisores works!</p>\n"